module.exports = __webpack_public_path__ + "img/tapping-into-future-payments.53c8d54e.png";